module.exports = __webpack_public_path__ + "static/media/itzur_zulmart_t.9e4c170b.jpg";